import { render, staticRenderFns } from "./SequenceFlowProps.vue?vue&type=template&id=34f487bc"
import script from "./SequenceFlowProps.vue?vue&type=script&lang=js"
export * from "./SequenceFlowProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports